import * as React from "react";
import "./styles/TextField.scss";

interface Props {
    onChange?: (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
    onBlur?: (e: React.FocusEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
    placeholder?: string;
    label?: string;
    value?: string;
    onClick?: () => void;
    buttonText?: string;
    errorText?: string;
    type?: string;
    inputMode?: "search" | "text" | "email" | "tel" | "url" | "none" | "numeric" | "decimal";
}

const TextField = React.forwardRef<HTMLInputElement | HTMLTextAreaElement, Props>((
    { onChange, onBlur, placeholder, label, value, onClick, buttonText, errorText, type, inputMode, ...rest }, 
    ref
) => {
    if (type === "textarea") {
        return (
            <div className={"text-field-container"}>
                <div className="form-control wrapper-area" style={{ marginBottom: "2rem" }}>
                    {label && <label>{label}</label>}
                    <textarea {...rest} onChange={onChange} placeholder={placeholder} value={value} onBlur={onBlur} autoFocus={false} inputMode={inputMode} ref={ref as React.LegacyRef<HTMLTextAreaElement>} />
                    <span className={errorText !== undefined && errorText !== "" ? `text visible` : "text"}>{errorText}</span>
                </div>
            </div>
        );
    } else {
        return (
            <div className={"text-field-container"}>
                <div className="form-group">
                    {label && <label>{label}</label>}
                    <input {...rest} className={"form-control"} onChange={onChange} placeholder={placeholder} value={value} type={type} onBlur={onBlur} autoFocus={false} inputMode={inputMode} ref={ref as React.LegacyRef<HTMLInputElement>} />
                    {onClick && (<button className="input-group-append" onClick={onClick}>{buttonText}</button>)}
                    <span className={errorText !== undefined && errorText !== "" ? `text visible error` : "text"}>{errorText}</span>
                </div>
            </div>
        );
    }
});

export default TextField;